<template>
  <div class="app-change-payment-change-wrapper">
    <slot name="txtBeforeChangePayment"></slot>
    <b-form
      class="change-payment-form"
      :id="'form' + _uid">
        <EnterPaymentData
          :credit-card-redirect-url="creditCardRedirectUrl"
          :credit-card-frame-address="creditCardFrameAddress"
          :payment.sync="payment"
          :paymentInvalid.sync="paymentInvalid_"
          :payment-context="paymentContext"
          :no-payment-possible="true"
          :process-name="'changePayment'"
          :current-customer="currentCustomer"
        >
          <template #txtBeforePayment><slot name="txtPaymentBeforePayment"></slot></template>
          <template #lblCreditCard><slot name="lblPaymentCreditCard"></slot></template>
          <template #txtCcBefore><slot name="txtPaymentCcBefore"></slot></template>
          <template #txtCcInfoBefore><slot name="txtPaymentCcInfoBefore"></slot></template>
          <template #lblCcInfoCcHolder><slot name="lblPaymentCcInfoCcHolder"></slot></template>
          <template #lblCcInfoCcNumber><slot name="lblPaymentCcInfoCcNumber"></slot></template>
          <template #lblCcInfoCcType><slot name="lblPaymentCcInfoCcType"></slot></template>
          <template #lblCcInfoCcValidty><slot name="lblPaymentCcInfoCcValidty"></slot></template>
          <template #txtCcInfoAfter><slot name="txtPaymentCcInfoAfter"></slot></template>
          <template #txtCcInfoError><slot name="txtPaymentCcInfoError"></slot></template>
          <template #btnCcRestart><slot name="btnPaymentCcRestart"></slot></template>
          <template #txtCcAfter><slot name="txtPaymentCcAfter"></slot></template>
          <template #lblBankAccount><slot name="lblPaymentBankAccount"></slot></template>
          <template #lblBankAccountOwner><slot name="lblPaymentBankAccountOwner"></slot></template>
          <template #lblBankAccountIban><slot name="lblPaymentBankAccountIban"></slot></template>
          <template #txtBankAccountIbanLiveFeedback><slot name="txtPaymentBankAccountIbanLiveFeedback"></slot></template>
          <template #lblBankAccountPaymentConfirmation><slot name="lblPaymentBankAccountPaymentConfirmation"></slot></template>
          </EnterPaymentData>
    </b-form>
    <Stepper
      @next="next()"
      :show-prev="false"
      :disabled-next="$v.$invalid || loadingNext"
      :loading-next="loadingNext"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>

import EnterPaymentData from './EnterPaymentData.vue'
import { mapActions } from 'vuex'
import Stepper from '@/components/generic/Stepper.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { validationMixin } from 'vuelidate'
import slotProxy from '@/mixins/slotProxy'
export const stepName = 'changePayment'

export default {
  name: 'ChangePaymentData',
  components: {
    EnterPaymentData,
    Stepper

  },
  data () {
    return {
      paymentType: null,
      paymentInvalid_: true,
      payment: [],
      currentCustomer: {},
      loadingNext: false
    }
  },
  computed: {
    paymentContext: function () {
      const context = Object.assign({}, this.currentCustomer)
      delete context.__typename
      if (context.address) {
        delete context.address.__typename
      }
      return context
    }
  },
  mixins: [
    validationMixin,
    slotProxy()
  ],
  validations () {
    return {
      paymentInvalid_: {
        validPaymentIfRequired: (value, vm) => {
          if (vm.paymentRequired === false) {
            return true
          }
          return value === false
        }
      }
    }
  },
  methods: {
    ...mapActions('changePayment', [
      'changePayment'
    ]),
    next () {
      this.loadingNext = true
      this.payment.owner = this.currentCustomer.firstName + ' ' + this.currentCustomer.lastName
      this.changePayment({ changePaymentData: this.payment, nextStep: '' }).then(() => {
        this.loadingNext = false
      }, () => {
        this.loadingNext = false
      })
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query changePayment {
        currentCustomer {
            firstName,
            email,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            }
          }
      }`, this, 'currentCustomer', {}, null,
      { fetchPolicy: 'cache-first' })
    }
  },
  props: {
    creditCardFrameAddress: {
      type: String
    },
    creditCardRedirectUrl: {
      type: String
    }
  }
}
</script>
